import { render, staticRenderFns } from "./basicInfoCard.vue?vue&type=template&id=9c729906&scoped=true&"
import script from "./basicInfoCard.vue?vue&type=script&lang=js&"
export * from "./basicInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./basicInfoCard.vue?vue&type=style&index=0&id=9c729906&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c729906",
  null
  
)

export default component.exports